import convert from "convert-units";
import {
  coins_units,
  units,
  units_12,
  units_2,
  units_4,
  units_5,
} from "../constants.js";
import { convertUnits, DATA } from "./convert.js";
import { convertEnergy2 } from "./convertEnergy.js";

//Codigos que se ven en los formularios
/*export const fuelsCodes = {
  natural_gas: "Veh1",
  natural_gas_cost: "Veh2",
  glp: "Veh3",
  glp_cost: "Veh4",
  diesel: "Veh5",
  diesel_cost: "Veh6",
  biodiesel: "Veh7",
  cost_biodiesel: "Veh8",
  gasoline:"Veh9",
  gasoline_cost:"Veh10",
  ethanol: "Veh11",
  ethanol_cost: "Veh12",
  electricity_vehicles: "Veh13",
  cost_electricity_vehicles: "Veh14",
    natural_gas_vehicles: "Veh15",       // Cantidad de vehículos que usan Gas Natural
  glp_vehicles: "Veh16",              // Cantidad de vehículos que usan GLP (Gas Licuado de Petróleo)
  diesel_vehicles: "Veh17",           // Cantidad de vehículos que usan Diesel
  biodiesel_vehicles: "Veh18",        // Cantidad de vehículos que usan Biodiesel
  gasoline_vehicles: "Veh19",         // Cantidad de vehículos que usan Gasolina
  ethanol_vehicles: "Veh20",          // Cantidad de vehículos que usan Biocombustible (Etanol)
  electric_vehicles: "Veh21"          // Cantidad de vehículos eléctricos 100%


};*/
export const fuelsCodes = {
  // --- Gas Natural ---
  natural_gas: "Veh1", // Consumo de Gas Natural (MWh)
  natural_gas_cost: "Veh2", // Costo de Gas Natural (USD)

  // --- Gas Licuado de Petróleo (GLP) ---

  glp: "Veh3", // Consumo de GLP (MWh)
  glp_cost: "Veh4", // Costo de GLP (USD)

  // --- Diesel ---
  diesel: "Veh5", // Consumo de Diesel (MWh)
  diesel_cost: "Veh6", // Costo de Diesel (USD)

  // --- Biodiesel ---
  biodiesel: "Veh7", // Consumo de Diesel (MWh)
  cost_biodiesel: "Veh8", // Costo de Biodiesel (USD)

  // --- Gasolina ---
  gasoline: "Veh9", // Consumo de Gasolina (MWh)
  gasoline_cost: "Veh10", // Costo de Gasolina (USD)

  // --- Etanol ---
  ethanol: "Veh11", // Consumo de Etanol (MWh)
  ethanol_cost: "Veh12", // Costo de Etanol (USD)

  // --- Electricidad para vehículos ---
  electricity_vehicles: "Veh13", // Consumo de Electricidad en vehículos (MWh)
  cost_electricity_vehicles: "Veh14", // Costo de Electricidad en vehículos (USD)

  // --- Cantidad de vehículos por tipo de combustible ---
  natural_gas_vehicles: "Veh15", // Vehículos a Gas Natural
  glp_vehicles: "Veh16", // Vehículos a GLP
  diesel_vehicles: "Veh17", // Vehículos a Diesel
  biodiesel_vehicles: "Veh18", // Vehículos a Biodiesel
  gasoline_vehicles: "Veh19", // Vehículos a Gasolina
  ethanol_vehicles: "Veh20", // Vehículos a Etanol
  electric_vehicles: "Veh21", // Vehículos 100% eléctricos
};

//Codigos de los indicadores que se ven en el dashboard
export const fuelsKPIsCodes = {
  _natural_gas: "KPIVeh1",
  _glp: "KPIVeh2",
  _diesel: "KPIVeh3",
  // _gasoline_internal_vehicles: "KPIVeh6",
  _biodiesel: "KPIVeh4",
  _gasoline: "KPIVeh5",
  _ethanol: "KPIVeh6",
  _electricity_vehicles: "KPIVeh7",
  total_fuel_mwh: "KPIVeh8", // Combustible Total (estandarizado en MWh)
  total_vehicles: "KPIVeh9", // Cantidad total de Vehículos
  fuel_vehicle: "KPIVeh10", // Combustible total / vehículo
  total_fuel_cost: "KPIVeh11", // Costo combustible total,
};

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
export function fuelsFormulasIndicators(field, year, data, baseline, cantW) {
  //console.log(field)
  switch (field) {
    case "_natural_gas": {
      // ✅ Nuevo: Usar validMonths en lugar de 12 fijo
      const validMonths =
        Number(data["natural_gas_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw =
        Number(data["natural_gas_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;

      const totalFuel = Number(data["natural_gas"]?.[year]?.total) ?? 0;

      const fuelUnit = data["natural_gas"]?.[year]?.unit ?? "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(totalFuel, fuelUnit, targetUnit, "natural_gas", true) ||
        totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }

    case "_glp": {
      const validMonths =
        Number(data["glp_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw = Number(data["glp_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;

      // const vehiclesTotal = data["glp_vehicles"]?.[year]?.total / 12 || 0;
      const totalFuel = data["glp"]?.[year]?.total || 0;
      const fuelUnit = data["glp"]?.[year]?.unit || "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(totalFuel, fuelUnit, targetUnit, "glp", true) ||
        totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }

    case "_diesel": {
      const validMonths =
        Number(data["diesel_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw =
        Number(data["diesel_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;

      const totalFuel = data["diesel"]?.[year]?.total || 0;
      const fuelUnit = data["diesel"]?.[year]?.unit || "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(totalFuel, fuelUnit, targetUnit, "diesel", true) ||
        totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }

    case "_biodiesel": {
      const validMonths =
        Number(data["biodiesel_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw =
        Number(data["biodiesel_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;
      const totalFuel = data["biodiesel"]?.[year]?.total || 0;
      const fuelUnit = data["biodiesel"]?.[year]?.unit || "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(totalFuel, fuelUnit, targetUnit, "biodiesel", true) ||
        totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }

    case "_gasoline": {
      const validMonths =
        Number(data["gasoline_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw =
        Number(data["gasoline_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;
      const totalFuel = data["gasoline"]?.[year]?.total || 0;
      const fuelUnit = data["gasoline"]?.[year]?.unit || "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(totalFuel, fuelUnit, targetUnit, "gasoline", true) ||
        totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      // console.log("_gasoline:", {
      //   vehiclesTotalRaw,
      //   vehiclesTotal,
      //   totalFuel,
      //   fuelUnit,
      //   totalFuelConverted,
      //   fuelPerVehicle,
      //   year,
      // });

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }

    case "_ethanol": {
      const validMonths =
        Number(data["ethanol_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw =
        Number(data["ethanol_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;
      const totalFuel = data["ethanol"]?.[year]?.total || 0;
      const fuelUnit = data["ethanol"]?.[year]?.unit || "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(totalFuel, fuelUnit, targetUnit, "ethanol", true) ||
        totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }

    case "_electricity_vehicles": {
      const validMonths =
        Number(data["electric_vehicles"]?.[year]?.validMonths) ?? 12;

      const vehiclesTotalRaw =
        Number(data["electric_vehicles"]?.[year]?.total) ?? 0;

      const vehiclesTotal =
        validMonths > 0 ? vehiclesTotalRaw / validMonths : 0;
      const totalFuel = data["electricity_vehicles"]?.[year]?.total || 0;
      const fuelUnit = data["electricity_vehicles"]?.[year]?.unit || "";

      // Si ya está en KWh, mantener KWh. Si no, convertir a MWh
      const isKwh = fuelUnit.toLowerCase().replace(/\s+/g, "") === "kwh";
      const targetUnit = isKwh ? "kwh" : "kwh";
      const totalFuelConverted =
        convertEnergy2(
          totalFuel,
          fuelUnit,
          targetUnit,
          "electricity_vehicles",
          true,
        ) || totalFuel;
      const fuelPerVehicle =
        vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotal : 0;
      // const fuelPerVehicle =
      // vehiclesTotal > 0 ? totalFuelConverted / vehiclesTotalRaw : 0;

      return {
        total: fuelPerVehicle,
        unit: isKwh ? "KWh" : "KWh",
      };
    }
    case "total_fuel_mwh":
      return fuelsTotalMWh(year, data, baseline, cantW);

    case "total_vehicles": {
      const keys2 = [
        "natural_gas_vehicles",
        "glp_vehicles",
        "diesel_vehicles",
        "biodiesel_vehicles",
        "gasoline_vehicles",
        "ethanol_vehicles",
        "electric_vehicles",
      ];

      // Sumar el total de todos los vehículos y dividir por la cantidad de meses cargados
      const totalSum = keys2.reduce(
        (acc, k) => acc + (Number(data[k]?.[year]?.total) || 0),
        0,
      );
      const validMonths = keys2.reduce(
        (max, k) => Math.max(max, Number(data[k]?.[year]?.validMonths) || 0),
        0,
      );
      const total = validMonths > 0 ? totalSum / validMonths : 0;

      // Buscar la primera unidad disponible entre las claves
      const unit = keys2.map((k) => data[k]?.[year]?.unit).find(Boolean);

      return {
        total,
        unit,
      };
    }

    case "fuel_vehicle":
      // console.log(fuelsFormulasIndicators("total_fuel_mwh", year, data, baseline,cantW).total / fuelsFormulasIndicators("total_vehicles", year, data, baseline, cantW).total)
      return {
        total:
          fuelsFormulasIndicators("total_fuel_mwh", year, data, baseline, cantW)
            .total /
          fuelsFormulasIndicators("total_vehicles", year, data, baseline, cantW)
            .total,
        unit: "MWh",
      };
    case "total_fuel_cost": {
      const keys3 = [
        "natural_gas_cost",
        "glp_cost",
        "diesel_cost",
        "cost_biodiesel",
        "gasoline_cost",
        "ethanol_cost",
        "cost_electricity_vehicles",
      ];

      // Sumar todos los valores de "total", asegurándose que si no existen se sumen como 0
      const total = keys3.reduce(
        (acc, k) => acc + (data[k]?.[year]?.total ?? 0),
        0,
      );

      // Buscar la primera unidad disponible entre las claves
      const unit = keys3.map((k) => data[k]?.[year]?.unit).find(Boolean);

      return {
        total,
        unit,
      };
    }

    default:
      return false;
  }
}

//Suma los valores de los campos/claves pasadas como parametros
function addData(keys, year, data, unitSelected) {
  let suma = 0;
  //tomo como referencia el kwh
  for (let clave of keys) {
    if (data.hasOwnProperty(clave)) {
      suma +=
        convertUnits(
          data[clave]?.[year].total,
          data[clave]?.[year].unit,
          unitSelected,
        ) || 0;
    }
  }

  return suma;
}

//Suma los valores de los campos/claves pasadas como parametros
function addData2(keys, unitSelected) {
  let suma = 0;
  //tomo como referencia el kwh
  for (let clave of keys) {
    suma += convertUnits(clave?.total, clave?.unit, unitSelected) || 0;
  }

  return suma;
}

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineFuelsUnits = (value) => {
  if (
    value === "natural_gas" ||
    value === "glp" ||
    value === "_natural_gas" ||
    value === "_glp"
  )
    return units_4;
  else if (
    value === "natural_gas_cost" ||
    value === "glp_cost" ||
    value === "cost_heavy_fuel_oil" ||
    value === "cost_light_fuel_oil" ||
    value === "diesel_cost" ||
    value === "gasoline_cost_internal_vehicles" ||
    value === "cost_biodiesel" ||
    value === "biogas_cost" ||
    value === "ethanol_cost" ||
    value === "cost_electricity_vehicles" ||
    value === "_natural_gas_cost" ||
    value === "_glp_cost" ||
    value === "_cost_heavy_fuel_oil" ||
    value === "_cost_light_fuel_oil" ||
    value === "_diesel_cost" ||
    value === "_gasoline_cost_internal_vehicles" ||
    value === "_cost_biodiesel" ||
    value === "_biogas_cost" ||
    value === "_ethanol_cost" ||
    value === "_cost_electricity_vehicles" ||
    value === "natural_gas_cost_kpi" ||
    value === "glp_cost_kpi" ||
    value === "cost_heavy_fuel_oil_kpi" ||
    value === "cost_light_fuel_oil_kpi" ||
    value === "diesel_cost_kpi" ||
    value === "gasoline_cost_internal_vehicles_kpi" ||
    value === "cost_biodiesel_kpi" ||
    value === "biogas_cost_kpi" ||
    value === "ethanol_cost_kpi" ||
    value === "cost_electricity_vehicles_kpi" ||
    value === "total_fuel_cost" ||
    value === "gasoline_cost"
  ) {
    return coins_units;
  } else if (value === "biogas" || value === "ethanol") return units_2;
  else if (
    value === "cost_of_heavy_fuel_oil" ||
    value === "cost_of_heavy_fuel_oil_kpis"
  )
    return units_5;
  else if (value === "electricity_vehicles") return units;
  else if (
    value === "natural_gas_vehicles" || // Cantidad de vehículos que usan Gas Natural
    value === "glp_vehicles" || // Cantidad de vehículos que usan GLP (Gas Licuado de Petróleo)
    value === "diesel_vehicles" || // Cantidad de vehículos que usan Diesel
    value === "biodiesel_vehicles" || // Cantidad de vehículos que usan Biodiesel
    value === "gasoline_vehicles" || // Cantidad de vehículos que usan Gasolina
    value === "ethanol_vehicles" || // Cantidad de vehículos que usan Biocombustible (Etanol)
    value === "electric_vehicles" ||
    value === "total_vehicles"
  ) {
    return units_12;
  } else if (value === "total_fuel_mwh" || value === "fuel_vehicle") {
    return [{ key: 2, value: "MWh", name: "MWh" }];
  } else if (value === "diesel" || value === "gasoline") {
    return units_2;
  } else {
    return units;
  }
};

// Función de conversión entre unidades de masa, energía y volumen
// Conversión entre unidades de masa, energía y volumen para combustibles
// export function convertUnitsFuels(
//   valor,
//   unidadOrigen,
//   unidadDestino,
//   densidad,
//   unidadDensidad,
//   poderCalorifico,
//   unidadPoderCalorifico // << NUEVO: permite indicar "MJ/kg", "MWh/m3", etc.
// ) {

//   // --- Relaciones de conversión ---
//   const conversionesMasa = {
//     g: 1,
//     kg: 1e3,
//     lb: 453.592,
//     oz: 28.3495,
//     ton_metrica: 1e6,
//     ton_corta: 907185,
//   };

//   const conversionesEnergia = {
//     J: 1,
//     kWh: 3.6e6,
//     MWh: 3.6e9,
//     MJ: 1e6,
//     GJ: 1e9,
//     btu: 1055.06,
//     mmbtu: 1.055e9,
//   };

//   const conversionesVolumen = {
//     l: 1,
//     m3: 1000,
//     "US gallons": 3.78541,
//   };

//   // --- Convertir densidad a g/L ---
//   let densidadEnGL;
//   switch (unidadDensidad) {
//     case "g/cm3": densidadEnGL = densidad * 1000; break;
//     case "kg/m3": densidadEnGL = densidad / 1; break; // 1 kg/m³ = 1 g/L
//     case "kg/L": densidadEnGL = densidad * 1000; break;
//     case "g/L": densidadEnGL = densidad; break;
//     default: return "Unidad de densidad no válida";
//   }

//   // --- Normalizar poder calorífico a J por gramo ---
//   let poderCalorifico_J_por_g;
//   if (poderCalorifico && unidadPoderCalorifico) {
//     const [energiaUnit, masaVolUnit] = unidadPoderCalorifico.split("/");

//     // Convertir energía a Joules
//     const factorEnergia = conversionesEnergia[energiaUnit];
//     if (!factorEnergia) return "Unidad de energía en poder calorífico no válida";

//     // Determinar si el poder calorífico está dado por masa o por volumen
//     if (conversionesMasa[masaVolUnit]) {
//       // Por masa (e.g. MJ/kg, MWh/kg)
//       const factorMasa = conversionesMasa[masaVolUnit];
//       poderCalorifico_J_por_g = (poderCalorifico * factorEnergia) / factorMasa;
//     } else if (conversionesVolumen[masaVolUnit]) {
//       // Por volumen (e.g. MWh/m3)
//       const factorVolumen = conversionesVolumen[masaVolUnit];
//       poderCalorifico_J_por_g = (poderCalorifico * factorEnergia) / (factorVolumen * densidadEnGL);
//     } else {
//       return "Unidad de masa/volumen en poder calorífico no válida";
//     }
//   }

//   // --- Función auxiliar: convertir entre categorías ---
//   const convertir = (valor, origen, destino, tabla) => {
//     if (tabla[origen] && tabla[destino]) {
//       const base = valor * tabla[origen];
//       return base / tabla[destino];
//     }
//     return null;
//   };

//   // --- Conversiones dentro de una misma categoría ---
//   const entreMasas = convertir(valor, unidadOrigen, unidadDestino, conversionesMasa);
//   if (entreMasas !== null) return entreMasas;

//   const entreEnergias = convertir(valor, unidadOrigen, unidadDestino, conversionesEnergia);
//   if (entreEnergias !== null) return entreEnergias;

//   const entreVolumenes = convertir(valor, unidadOrigen, unidadDestino, conversionesVolumen);
//   if (entreVolumenes !== null) return entreVolumenes;

//   // --- Conversiones cruzadas (masa-volumen-energía) ---
//   if (!poderCalorifico_J_por_g)
//     return "Se requiere poder calorífico con su unidad (por ejemplo: 42.7 MJ/kg)";

//   // Masa → Energía
//   if (conversionesMasa[unidadOrigen] && conversionesEnergia[unidadDestino]) {
//     const masaEnGramos = valor * conversionesMasa[unidadOrigen];
//     const energiaEnJ = masaEnGramos * poderCalorifico_J_por_g;
//     return energiaEnJ / conversionesEnergia[unidadDestino];
//   }

//   // Energía → Masa
//   if (conversionesEnergia[unidadOrigen] && conversionesMasa[unidadDestino]) {
//     const energiaEnJ = valor * conversionesEnergia[unidadOrigen];
//     const masaEnGramos = energiaEnJ / poderCalorifico_J_por_g;
//     return masaEnGramos / conversionesMasa[unidadDestino];
//   }

//   // Volumen → Energía
//   if (conversionesVolumen[unidadOrigen] && conversionesEnergia[unidadDestino]) {
//     const volumenEnLitros = valor * conversionesVolumen[unidadOrigen];
//     const masaEnGramos = volumenEnLitros * densidadEnGL;
//     const energiaEnJ = masaEnGramos * poderCalorifico_J_por_g;
//     return energiaEnJ / conversionesEnergia[unidadDestino];
//   }

//   // Energía → Volumen
//   if (conversionesEnergia[unidadOrigen] && conversionesVolumen[unidadDestino]) {
//     const energiaEnJ = valor * conversionesEnergia[unidadOrigen];
//     const masaEnGramos = energiaEnJ / poderCalorifico_J_por_g;
//     const volumenEnLitros = masaEnGramos / densidadEnGL;
//     return volumenEnLitros / conversionesVolumen[unidadDestino];
//   }

//   // Masa ↔ Volumen
//   if (conversionesMasa[unidadOrigen] && conversionesVolumen[unidadDestino]) {
//     const masaEnGramos = valor * conversionesMasa[unidadOrigen];
//     const volumenEnLitros = masaEnGramos / densidadEnGL;
//     return volumenEnLitros / conversionesVolumen[unidadDestino];
//   }

//   if (conversionesVolumen[unidadOrigen] && conversionesMasa[unidadDestino]) {
//     const volumenEnLitros = valor * conversionesVolumen[unidadOrigen];
//     const masaEnGramos = volumenEnLitros * densidadEnGL;
//     return masaEnGramos / conversionesMasa[unidadDestino];
//   }

//   return "Conversión no válida";
// }

export const densidades = {
  _natural_gas: {
    density: 0.717,
    unit_density: "kg/m3",
  },
  glp: {
    density: 0.55,
    unit_density: "kg/m3",
  },
  heavy_fuel_oil: {
    densidad: 950,
    unit_density: "kg/m3",
  },
  light_fuel_oil: {
    density: 850,
    unit_density: "kg/m³",
  },
  diesel: {
    density: 832,
    unit_density: "kg/m3",
  },
  gasoline: {
    density: 737,
    unit_density: "kg/m3",
  },
  biodiesel: {
    density: 880,
    unit_density: "kg/m3",
  },
  biogas: {
    density: 1.2,
    unit_density: "kg/m3",
  },
  ethanol: {
    density: 789,
    unit_density: "kg/m3",
  },
};

export const fuentesEnergia = {
  natural_gas: {
    poder_calorifico: 0.01056, // 38 MJ/m3
    unidad_poder_calorifico: "MWh/m3",
  },
  glp: {
    poder_calorifico: 0.01278, // 46 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  heavy_fuel_oil: {
    poder_calorifico: 0.01111, // 40 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  light_fuel_oil: {
    poder_calorifico: 0.01194, // 43 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  diesel: {
    poder_calorifico: 0.01194, // 43 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  gasoline: {
    poder_calorifico: 0.01222, // 44 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  biodiesel: {
    poder_calorifico: 0.01028, // 37 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  ethanol: {
    poder_calorifico: 0.0075, // 27 MJ/kg
    unidad_poder_calorifico: "MWh/kg",
  },
  biogas: {
    poder_calorifico: 0.00583, // 21 MJ/m3
    unidad_poder_calorifico: "MWh/m3",
  },
};

export const fuelCodeToType = {
  _natural_gas: "natural_gas",
  natural_gas: "natural_gas",
  _glp: "glp",
  glp: "glp",
  _diesel: "diesel",
  diesel: "diesel",
  _biodiesel: "biodiesel",
  biodiesel: "biodiesel",
  _gasoline: "gasoline",
  gasoline: "gasoline",
  _ethanol: "ethanol",
  ethanol: "ethanol",
  _electricity_vehicles: "electricity_standard",
  electricity_vehicles: "electricity_standard",
};

const conversionesMasa = {
  g: 1,
  kg: 1000,
  lb: 453.592,
  oz: 28.3495,
  "ton (métrica)": 1e6,
  "ton (corta)": 907184.74,
};

const conversionesVolumen = {
  m3: 1,
  l: 1000,
  "US gallons": 264.172,
};

const conversionEnergia = {
  J: 1,
  kWh: 3.6e6,
  MWh: 3.6e9,
  MJ: 1e6,
  GJ: 1e9,
};

export function convertUnitsFuels(
  valor,
  unidadOrigen,
  unidadDestino,
  tipoCombustible,
) {
  unidadOrigen = unidadOrigen?.toLowerCase?.() ?? unidadOrigen;
  unidadDestino = unidadDestino?.toLowerCase?.() ?? unidadDestino;
  const combustible = DATA[tipoCombustible];
  if (!combustible || combustible.calorific == null) return null;

  let energiaJ;

  // --- Normalizar a energía en J ---
  if (conversionEnergia[unidadOrigen]) {
    energiaJ = valor * conversionEnergia[unidadOrigen];
  } else if (conversionesVolumen[unidadOrigen]) {
    // volumen → m³
    const volumenM3 = valor / conversionesVolumen[unidadOrigen];

    // masa en toneladas
    const masaTn = (volumenM3 * combustible.density) / 1000; // kg → Tn

    energiaJ = masaTn * combustible.calorific * 1e6; // MJ → J
  } else if (conversionesMasa[unidadOrigen]) {
    const masaGr = valor * conversionesMasa[unidadOrigen];
    const masaTn = masaGr / 1e6;
    energiaJ = masaTn * combustible.calorific * 1e6;
  } else {
    return null; // unidad no soportada
  }

  // --- Convertir a unidad destino ---
  if (conversionEnergia[unidadDestino]) {
    return energiaJ / conversionEnergia[unidadDestino];
  } else if (conversionesVolumen[unidadDestino]) {
    // de energía → volumen
    const masaTn = energiaJ / (combustible.calorific * 1e6);
    const volumenM3 = (masaTn * 1000) / combustible.density; // Tn → kg → volumen
    return volumenM3 * conversionesVolumen[unidadDestino];
  } else if (conversionesMasa[unidadDestino]) {
    const masaTn = energiaJ / (combustible.calorific * 1e6);
    const masaGr = masaTn * 1e6;
    return masaGr / conversionesMasa[unidadDestino];
  }

  return null;
}

// 🔹 Función anterior (comentada) - usaba multiplicación por poder calorífico
// export function fuelsTotalMWh(year, data) {
//   const fuels = [
//     "natural_gas",
//     "glp",
//     "diesel",
//     "biodiesel",
//     "gasoline",
//     "ethanol",
//     //"electricity_vehicles",
//   ];
//
//   let totalMWh = 0;
//   if (!data) return;
//   for (const fuel of fuels) {
//     // Buscar el registro del combustible en data
//     const registro = data[fuel]?.[year];
//
//     if (!registro || !registro.total) continue; // si no hay datos, salta
//
//     const total = registro.total; // cantidad (en kg, L, m3, etc.)
//     const unidad = registro.unit; // unidad original
//     const poderCalorifico = fuentesEnergia[fuel]?.poder_calorifico || 0;
//     const unidadPoder =
//       fuentesEnergia[fuel]?.unidad_poder_calorifico || "MWh/kg";
//
//     let valorMWh = 0;
//
//     // --- Ajuste según la unidad del poder calorífico ---
//     if (unidadPoder === "MWh/kg" && unidad === "kg") {
//       valorMWh = total * poderCalorifico;
//     } else if (unidadPoder === "MWh/l" && unidad === "l") {
//       valorMWh = total * poderCalorifico;
//     } else if (unidadPoder === "MWh/m3" && unidad === "m3") {
//       valorMWh = total * poderCalorifico;
//     } else if (unidadPoder === "MWh/kWh" && unidad === "kWh") {
//       // Para casos eléctricos o equivalentes
//       valorMWh = total * poderCalorifico;
//     } else {
//       // Si no coincide, dejar un aviso
//       console.warn(
//         `⚠️ No se pudo convertir correctamente ${fuel}: unidad ${unidad} vs ${unidadPoder}`
//       );
//       continue;
//     }
//
//     totalMWh += valorMWh;
//   }
//
//   console.log("Total en MWh:", totalMWh.toFixed(2));
//
//   return {
//     total: totalMWh,
//     unit: "MWh",
//   };
// }

// 🆕 Nueva función usando convertEnergy2 (división por factor)
export function fuelsTotalMWh(year, data) {
  const fuels = [
    "natural_gas",
    "glp",
    "diesel",
    "biodiesel",
    "gasoline",
    "ethanol",
    "electricity_vehicles",
  ];

  let totalMWh = 0;
  if (!data) return;

  for (const fuel of fuels) {
    // Buscar el registro del combustible en data
    const registro = data[fuel]?.[year];

    if (!registro || !registro.total) continue; // si no hay datos, salta

    const total = registro.total; // cantidad (en kg, L, m3, etc.)
    const unidad = registro.unit; // unidad original

    // Usar convertEnergy2 para la conversión correcta (división por factor)
    const valorMWh = convertEnergy2(total, unidad, "mwh", fuel, true);

    if (valorMWh === null || valorMWh === undefined) {
      console.warn(
        `⚠️ No se pudo convertir correctamente ${fuel}: ${total} ${unidad} a MWh`,
      );
      continue;
    }

    totalMWh += valorMWh;
  }

  console.log("Total en MWh:", totalMWh.toFixed(2));

  return {
    total: totalMWh,
    unit: "MWh",
  };
}

export function convertFuel(
  valor,
  unidadOrigen,
  unidadDestino,
  tipoCombustible,
) {
  // 🔹 Si viene con prefijo "_", lo normalizamos
  const tipoNormalizado = fuelCodeToType[tipoCombustible] || tipoCombustible;

  const info = DATA[tipoNormalizado];
  if (!info || !info.density || !info.calorific) return null; // si no existe o no tiene datos, no devuelve nada

  const densidad = info.density;
  const poderCalorifico = info.calorific;

  return convertUnitsFuels(valor, unidadOrigen, unidadDestino, tipoCombustible);
}

export const convertUnitsFinal = (value, unita, unitb, material = "") => {
  try {
    const esMoneda = (unidad) =>
      coins_units.some((moneda) => moneda.value === unidad);

    // Si las unidades de origen y destino son iguales, no hacer conversión
    if (!value) {
      return 0;
    } else {
      if (unita === unitb) {
        return value;
      }

      // Si estamos trabajando con monedas, aplicamos la conversión de divisas
      if (esMoneda(unita) && esMoneda(unitb)) {
        return value;
      }

      // Si no es moneda, intentamos usar la librería 'convert'
      const result = convert(value).from(unita).to(unitb);
      // Si la conversión falla y devuelve NaN, vamos a intentar con la función personalizada
      if (isNaN(result)) {
        //console.log('La librería convert-units no pudo realizar la conversión. Intentando con la función personalizada...');
        const result2 = convertFuel(value, unita, unitb, material);

        return result2;
        //return value;
      }
      return result;
    }
  } catch (error) {
    try {
      const result2 = convertFuel(value, unita, unitb, material);
      //console.log(unita,unitb,material,result2)
      return result2;
    } catch {
      // Si ocurre un error en la librería o en la función personalizada, lo capturamos
      console.error(`Error de conversión: ${error.message}`);
      return null; // Retornamos null si hay un error
    }
  }
};
